import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@UILibrary/Text'
import { Stack } from '@UILibrary/Stack/Stack'
import { Icon } from '@UILibrary/Icon/Icon'
import { getFinancialTextColor } from '@utils/financialHealth'

export const ProgressComparison = ({ startValue, currentValue }) => {
  const startColor = getFinancialTextColor(startValue)
  const currentColor = getFinancialTextColor(currentValue)

  return (
    <Stack horizontal alignItems="center" justifyContent="center" spacing="l">
      <div>
        <Text body as="p" colour={startColor} margin='none'>Start</Text>
        <Text title1b as="h1" colour={startColor}>{startValue}%</Text>
      </div>

      <Icon name="chevron-double-right" size="large" />

      <div>
        <Text body as="p" colour={currentColor} margin='none'>Current</Text>
        <Text title1b as="h1" colour={currentColor}>{currentValue}%</Text>
      </div>
    </Stack>
  )
}

ProgressComparison.propTypes = {
  startValue: PropTypes.number.isRequired,
  currentValue: PropTypes.number.isRequired,
}
